import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var infoClassName = {
  normal: 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500',
  disabled: 'dark:tw-text-neutral-dark-600 tw-text-neutral-light-500',
  error: 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500'
};
var Info = function Info(_ref) {
  var info = _ref.info,
    inputState = _ref.inputState;
  return /*#__PURE__*/_jsx("p", {
    className: clsx('tw-font-body5', infoClassName[inputState]),
    children: info
  });
};
export default Info;